/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface VitalGetGrowthChart$Params {
  practiceId?: string | null;
  patientId?: string | null;
  chartType?: number;
}

export function vitalGetGrowthChart(http: HttpClient, rootUrl: string, params?: VitalGetGrowthChart$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, vitalGetGrowthChart.PATH, 'get');
  if (params) {
    rb.query('practiceId', params.practiceId, {});
    rb.query('patientId', params.patientId, {});
    rb.query('chartType', params.chartType, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

vitalGetGrowthChart.PATH = '/vital/growthChart';
